import { useEffect, useRef, useState } from "react";

export default function SkuAutocomplete({ skus, onSelect }) {
    const [query, setQuery] = useState("");
    const [filtered, setFiltered] = useState([]);
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    useEffect(() => {
        const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
        if (!terms.length) { setFiltered([]); return; }
        setFiltered(
            skus
                .filter((s) => {
                    const haystack = [s.name, s.sku, s.color, s.size, s.type]
                        .filter(Boolean)
                        .join(" ")
                        .toLowerCase();
                    return terms.every((t) => haystack.includes(t));
                })
                .slice(0, 30)
        );
    }, [query, skus]);

    const handleSelect = (sku) => {
        onSelect(sku);
        setQuery("");
        setOpen(false);
    };

    return (
        <div ref={wrapperRef} className="position-relative w-100">
            <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Пошук по назві, SKU, кольору, розміру…"
                value={query}
                onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
                onFocus={() => query.trim() && setOpen(true)}
            />

            {open && filtered.length > 0 && (
                <ul
                    className="list-group position-absolute shadow"
                    style={{ top: "calc(100% + 2px)", zIndex: 100, maxHeight: 280, overflowY: "auto", width: "100%" }}
                >
                    {filtered.map((s) => (
                        <li
                            key={s.id}
                            className="list-group-item list-group-item-action py-2 px-3"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSelect(s)}
                        >
                            <div className="d-flex align-items-baseline gap-2">
                                <span className="fw-medium">{s.name}</span>
                                {s.sku && <small className="text-muted">#{s.sku}</small>}
                            </div>
                            {(s.type || s.color || s.size) && (
                                <div className="text-muted" style={{ fontSize: "0.78rem" }}>
                                    {[s.type, s.color, s.size].filter(Boolean).join(" · ")}
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            )}

            {open && query.trim() && filtered.length === 0 && (
                <div
                    className="position-absolute bg-white border rounded p-2 text-muted small"
                    style={{ top: "calc(100% + 2px)", zIndex: 100, width: "100%" }}
                >
                    Нічого не знайдено
                </div>
            )}
        </div>
    );
}
